import {FrmSceneLayout} from "../../drawfrm/FrmSceneLayout";
import {DoorElevView} from "../doorElev/DoorElevScene";
import {ExportScene} from "./ExportScene";
import {GlassScheduleRow} from "./GlassSchedule";
import {doorLiteGlass} from "../../model/glass/MdGlass";

// simplified door elevation for a submittal: reuses the door-elevation view with its
// dimensions drawn engineering-drawing style, stacked outside the leaf (overall size,
// lites, door hardware). A pair draws both leaves side-by-side; a single draws the one
// leaf. No glass schedule is drawn under it — each lite carries its mark ("G1") on the
// drawing and the submittal prints the lite details as a table of its own.
export class DoorExportScene extends ExportScene {
    // the leaf views built by buildContent, in drawing order. Read by glassScheduleRows,
    // which runs after buildContent.
    private leafViews: DoorElevView[] = [];

    protected buildContent(): FrmSceneLayout {
        this.leafViews = [];

        const active = this.track(new DoorElevView(this.elev, input => this.add(input), true, {externalDims: true}));
        this.leafViews.push(active);

        if(!this.elev.frameSpec.isPair) {
            return active.getLayout();
        }

        const inactive = this.track(new DoorElevView(this.elev, input => this.add(input), false, {externalDims: true}));
        this.leafViews.push(inactive);

        return FrmSceneLayout.row(
            active.getLayout().grow(1),
            inactive.getLayout().grow(1),
        ).gap(60);
    }

    // every lite on each drawn leaf, in drawing order: the active leaf first, then the
    // inactive leaf of a pair. The sizes come from the views, which resolved each lite
    // against the leaf it was drawn on, so a locked offset on a resized door reports the
    // size on the drawing rather than the one the design was saved with.
    //
    // A door lite holds one pane in the middle of the leaf, so it is always "center"
    // glazed — the two-pane split the frame grid can ask for has no door equivalent.
    protected glassScheduleRows(): GlassScheduleRow[] {
        const rows: GlassScheduleRow[] = [];

        for(const view of this.leafViews) {
            for(const lite of view.measuredLites()) {
                rows.push({
                    mark: lite.mark || "",
                    glazing: "center",
                    cutOut: {width: lite.width.get(), height: lite.height.get()},
                    glass: doorLiteGlass(lite),
                });
            }
        }

        return rows;
    }
}
